import { NgModule } from '@angular/core';
import { Router, RouterModule, Routes }  from '@angular/router';
import { HomeComponent } from 'app/pages/home/home.component';
import { CoreModule } from 'app/core/core.module';
import { CommonModule } from '@angular/common';


const appRoutes: Routes = [
  { path: '',       component: HomeComponent }
];


@NgModule({
  imports: [
    CoreModule,
    CommonModule,
    RouterModule.forChild(
      appRoutes
    ),

  ],
  declarations: [
    HomeComponent
  ],
  exports: [],
  providers: []
})
export class HomeModule { }


// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/randonneurs-2018-build-and-to-local/src/app/pages/home/home.module.ts